export const ADD_ALLOWANCES = 'ADD_ALLOWANCES'
export const ADD_ALLOWANCE = 'ADD_ALLOWANCE'
